import { withLayoutProps } from '@/utils/withLayoutProps';

import { TripleSection, TripleSectionImage, TripleSectionText } from './styles';

import { Paragraph } from '../../Paragraph';

const SAMPLE_IMAGE =
  'https://images.unsplash.com/photo-1627935622792-8fec579a27e6?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

const ItineraryTipsTriple = withLayoutProps(() => (
  <TripleSection>
    {[0, 1, 2].map((item) => (
      <div key={item}>
        <TripleSectionImage src={SAMPLE_IMAGE} alt="image madeira" />
        <TripleSectionText>
          <h4>Live muziek</h4>
          <Paragraph>
            Loop &apos;s avonds over straat en geniet van de livemuziek uit debarretjes en muziekcafés. Het is
            verleidelijk rond het centrum teblijven.
          </Paragraph>
        </TripleSectionText>
      </div>
    ))}
  </TripleSection>
));

export { ItineraryTipsTriple };
